import { SubmitButtonShared } from './submit-button-shared';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GenerateShared } from './generate-shared';

@Injectable()
export class RadioButtonShared {
  constructor(
    private generateShared: GenerateShared,
    private submitButtonShared: SubmitButtonShared
  ) {}

  private radioButtonClickObs = new BehaviorSubject<boolean>(false);
  radioButtonClickObs$ = this.radioButtonClickObs.asObservable();

  radioButtonClicked(name: string, type: string) {
    if (type === 'disease') {
      let diseases = this.generateShared.getDiseases();
      if (diseases.includes(name)) {
        diseases.splice(diseases.indexOf(name), 1);
      } else {
        diseases.push(name);
      }
      this.generateShared.setDiseases(diseases);
    } else if (type === 'hatedFood') {
      let hatedFoods = this.generateShared.getHatedFoods();
      if (hatedFoods.includes(name)) {
        hatedFoods.splice(hatedFoods.indexOf(name), 1);
      } else {
        hatedFoods.push(name);
      }
      this.generateShared.setHatedFoods(hatedFoods);
    } else if (type === 'fastingDays') {
      let fastingDays = this.generateShared.getFastingDays();
      if (fastingDays.includes(name)) {
        fastingDays.splice(fastingDays.indexOf(name), 1);
      } else {
        if (fastingDays.length < this.generateShared.selectedDietType.fasting) {
          fastingDays.push(name);
        }
      }
      if (fastingDays.length < this.generateShared.selectedDietType.fasting) {
        this.submitButtonShared.activateNextButton(false);
      } else {
        this.submitButtonShared.activateNextButton(true);
      }
      this.generateShared.setFastingDays(fastingDays);
    }
    this.radioButtonClickObs.next(true);
    this.radioButtonClickObs.next(false);
  }
}
